import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { i18nTranslateOrFallback } from '../../util';
import { ConsentError, ErrorParams, ErrorType, isDevelopment } from '../../constants';

import PropTypes from 'prop-types';
import DevelopmentDetails from './DevelopmentDetails';
import OnStarContainer from '../OnStarContainer';
import { logToRemote } from '../../util/log-util';

const keyTitleAndDesc = (status, moreInfo) => {
  let keyTitle, keyDesc;

  if (status === '401' || status === 401 || status === '403' || status === 403) {
    keyTitle = `${ErrorType.consentError}.${ConsentError.accessDenied}.title`;
    keyDesc = `${ErrorType.consentError}.${ConsentError.accessDenied}.description`;
  } else if (typeof moreInfo === 'string' && moreInfo.toLowerCase().includes(ErrorType.consentError)) {
    keyTitle = `${moreInfo}.title`;
    keyDesc = `${moreInfo}.description`;
  } else if (typeof moreInfo === 'string' && moreInfo.toLowerCase().includes(ErrorType.papiError)) {
    keyDesc = `${moreInfo}`;
  } else {
    keyTitle = `${ErrorType.consentError}.${ConsentError.serverError}.title`;
    keyDesc = `${ErrorType.consentError}.${ConsentError.serverError}.description`;
  }

  return { keyTitle, keyDesc };
};

export const shouldDisplayReturnButton = (moreInfo) => {
  return (
    moreInfo !== `${ErrorType.consentError}.${ConsentError.unknownClient}` &&
    moreInfo !== `${ErrorType.consentError}.${ConsentError.missingQueryParams}`
  );
};

export const populateErrorVars = (from, to) => {
  if (from && to) {
    const errorKeys = Object.keys(ErrorParams);
    errorKeys.forEach((key) => {
      if (from[key]) to[key] = from[key];
    });
  }
};

const state = {};

const ErrorPage = (props) => {
  const location = useLocation();
  const { i18n } = useTranslation();
  const history = useHistory();

  populateErrorVars(props, state);
  populateErrorVars(location.state, state);

  const { code, desc, msg, status, moreInfo, subDesc } = state;

  const { keyTitle, keyDesc } = keyTitleAndDesc(status, moreInfo);
  const errorTitle = i18nTranslateOrFallback(i18n, keyTitle, 'Error');
  const errorDesc = i18nTranslateOrFallback(i18n, keyDesc, null);

  let subCodeDesc = null;

  if (keyDesc.includes(ErrorType.papiError)) {
    subCodeDesc = subDesc;
  }

  const onHandleReturn = () => {
    history.goBack();
  };

  logToRemote({
    code: 500,
    level: 'error',
    src: 'ErrorPage/index.js',
    ...state,
  });

  return (
    <OnStarContainer title={i18n.t('papi.general.error.occured')}>
      <section>
        <div className='span10 ng-scope'>
          {isDevelopment && <DevelopmentDetails status={status} code={code} desc={desc} msg={msg} />}
          {errorTitle && (
            <div className='subheading' id='error-title'>
              {errorTitle}
            </div>
          )}
          {subCodeDesc && <p id='subCodeDesc'>{subCodeDesc}</p>}
          {errorDesc && <p id='error-desc'>{errorDesc}</p>}
          {shouldDisplayReturnButton(moreInfo) && (
            <button id='return-btn' className='square-button' onClick={onHandleReturn}>
              {i18n.t('papi.general.return.lable')}
            </button>
          )}
        </div>
      </section>
    </OnStarContainer>
  );
};

ErrorPage.propTypes = {
  subCode: PropTypes.string,
};

export default ErrorPage;
